import { createContext, useContext, type ReactNode } from 'react'

export interface AnonymousModeValue {
  isAnonymous: true
  dashboardId: string
}

const AnonymousModeContext = createContext<AnonymousModeValue | null>(null)

export function AnonymousModeProvider({ value, children }: { value: AnonymousModeValue; children: ReactNode }) {
  return <AnonymousModeContext.Provider value={value}>{children}</AnonymousModeContext.Provider>
}

export function useAnonymousMode(): AnonymousModeValue | null {
  return useContext(AnonymousModeContext)
}
